import { isDevelopment } from '../../lib/constants';

export const getLoadInquiryFormJavaScript = () => {
	const environment = isDevelopment
		? `/${ process.env.NEXT_PUBLIC_ENVIRONMENT }`
		: '';
	const hostname =
		typeof process.env.NEXT_PUBLIC_ENVIRONMENT === 'string' &&
		[ 'PRODUCTION', 'DEMO' ].includes( process.env.NEXT_PUBLIC_ENVIRONMENT )
			? 'inquiries.rockpapercoin.com'
			: 'inquiries-dev.rockpapercoin.com';
	const formURI = `//${ hostname }${ environment }`;
	return `(n=>{var e=new XMLHttpRequest,a=document.createElement("progress"),t=(a.setAttribute("aria-label","Content loading…"),document.getElementById("inquiry-form"));t&&(t.appendChild(a),e.addEventListener("progress",function(e){e.lengthComputable&&(e.total,a.setAttribute("value",e.loaded),a.setAttribute("max",e.total))},!1)),e.addEventListener("load",function(e){var e=e.target,t=document.createElement("script");t.innerHTML=e.responseText,t.dataset.host=n,document.documentElement.appendChild(t),t.addEventListener("load",function(){a.remove()})},!1),e.open("GET",n+"/index.js?cb="+(new Date).getTime(),!0),e.send()})('${ formURI }');`;
};

export const getHTML = (
	apiURL: string,
	apiKey: string,
	organizationId: string
) =>
	`<div id="inquiry-form" ${
		isDevelopment ? `data-api="${ apiURL }"` : ''
	} data-api-key="${ apiKey }" data-organization-id="${ organizationId }"></div>`;

export const InquiriesConfigurationSteps = {
	Setup: 'setup',
	Style: 'style',
	Confirmation: 'confirmation',
	Publish: 'publish',
} as const;

export type InquiriesConfigurationStepsType =
	typeof InquiriesConfigurationSteps;
export type InquiriesConfigurationStepsValue =
	InquiriesConfigurationStepsType[keyof InquiriesConfigurationStepsType];

export const queryValueIsInquiriesConfigurationStep = (
	potentialStep:
		| string
		| string[]
		| undefined
		| typeof InquiriesConfigurationSteps
): potentialStep is InquiriesConfigurationStepsValue =>
	typeof potentialStep === 'string' &&
	Object.values<string>( InquiriesConfigurationSteps ).includes( potentialStep );

export const Title = {
	[ InquiriesConfigurationSteps.Setup ]: 'Inquiries Form Setup',
	[ InquiriesConfigurationSteps.Style ]: 'Inquiries Form Styling',
	[ InquiriesConfigurationSteps.Confirmation ]: 'Inquiries Form Confirmation',
	[ InquiriesConfigurationSteps.Publish ]: 'Inquiries Form Publish Markup',
};
